<template>
  <div id="app">
	<topMenu></topMenu>
    <router-view/>
  </div>
</template>

<script>

export default {
  name: 'app'
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

body{
	overflow-x: hidden;
}

button{
	border-radius:5px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue